import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./carDetails.css";
import { Car, CarPriceRange, Language } from "../../types";
import { carcDict, getPriceRangeText } from "../../utilities";

interface CarDetailsProps {
  car: Car;
  language: Language;
  withPadding?: boolean;
}

export const CarDetails: React.FC<CarDetailsProps> = ({
  car,
  language,
  withPadding,
}) => {
  return (
    <div className="CarDetails">
      <div className="CarDetails-header">
        <img
          className="CarDetails-logo"
          src={`/images/logos/${car.logo.replace(" ", "").toLowerCase()}`}
          alt={`${car.make} logo`}
        />
        <h2>
          {car.make} {car.model}
        </h2>
      </div>
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        modules={[EffectCoverflow, Pagination, Navigation]}
        effect="coverflow"
        loading="lazy"
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
      >
        {[...Array(car.imagesAmount)].map((_, index) => (
          <SwiperSlide key={index}>
            <img
              loading="lazy"
              src={`/images/cars/${car.id}/${index + 1}.webp`}
              alt={car.make}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className={`CarDetails-detailsContainer ${
          withPadding ? "CarDetails-detailsContainer-withPadding" : ""
        }`}
      >
        <div className="CarDetails-details">
          <div className="CarDetails-details-item">
            <span>{carcDict[language].productionYear}</span>
            <span>{car.productionYear}</span>
          </div>
          <div className="CarDetails-details-item">
            <span>{carcDict[language].fuel}</span>
            <span>{carcDict[language].fuelType[car.fuelType]}</span>
          </div>
          <div className="CarDetails-details-item">
            <span>{carcDict[language].transmission}</span>
            <span>{carcDict[language].transmissionType[car.transmission]}</span>
          </div>
          <div className="CarDetails-details-item">
            <span>{carcDict[language].seats}</span>
            <span>{car.seats}</span>
          </div>
        </div>
        <div className="CarDetails-prices">
          <div className="CarDetails-pricesTitle">
            <strong>{carcDict[language].pricesTitle}</strong>
          </div>
          {Object.entries(car.price).map(([key, value]) => (
            <div className="CarDetails-priceItem" key={key}>
              {getPriceRangeText(Number(key), language)}
              {" : "}
              {Number(key) === CarPriceRange.LongTerm
                ? carcDict[language].longTerm
                : value + " " + carcDict[language].euroPerDay}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
